import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

function CommunityServiceForm({ offenses = [], onSubmit, initialData = {}, onCancel }) {
  const [formData, setFormData] = useState({
    offense_id: '',
    task_description: '',
    hours_required: '',
    hours_completed: 0,
    status: 'Assigned',
  });
  const [deadline, setDeadline] = useState(null);
  const isEditing = !!initialData.id;

  useEffect(() => {
    if (!isEditing && offenses.length > 0) {
      setFormData(prev => ({ ...prev, offense_id: offenses[0].id }));
    }
    if (isEditing) {
      setDeadline(initialData.deadline ? new Date(initialData.deadline) : null);
      setFormData({
        offense_id: initialData.offense_id || '',
        task_description: initialData.task_description || '',
        hours_required: initialData.hours_required || '',
        hours_completed: initialData.hours_completed || 0,
        status: initialData.status || 'Assigned',
      });
    }
  }, [initialData, isEditing, offenses]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ ...formData, deadline });
  };

  return (
    <div className="card p-6 mt-4 bg-slate-50 border-gold">
      <h3 className="text-xl font-bold text-slate-800 mb-4">{isEditing ? 'Update' : 'Assign'} Community Service</h3>
      <form onSubmit={handleSubmit}>
        <div className="space-y-4">
          {!isEditing && (
            <>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">For Offense</label>
                <select name="offense_id" value={formData.offense_id} onChange={handleChange} required>
                  {offenses.map(o => <option key={o.id} value={o.id}>{o.offense_type} ({o.case_number})</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Task Description</label>
                <textarea name="task_description" value={formData.task_description} onChange={handleChange} required />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Hours Required</label>
                  <input type="number" name="hours_required" value={formData.hours_required} onChange={handleChange} required />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Deadline</label>
                  <DatePicker selected={deadline} onChange={(date) => setDeadline(date)} className="w-full" dateFormat="dd/MM/yyyy" />
                </div>
              </div>
            </>
          )}
          {isEditing && (
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Hours Completed</label>
                <input type="number" name="hours_completed" value={formData.hours_completed} onChange={handleChange} required />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Status</label>
                <select name="status" value={formData.status} onChange={handleChange}>
                  <option value="Assigned">Assigned</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Completed">Completed</option>
                </select>
              </div>
            </div>
          )}
        </div>
        <div className="flex justify-end gap-4 pt-4 mt-6 border-t border-slate-200">
          <button type="button" onClick={onCancel} className="bg-slate-200 text-slate-700 hover:bg-slate-300 font-bold py-2 px-4 rounded-lg">Cancel</button>
          <button type="submit" className="bg-gold text-white hover:bg-gold-dark font-bold py-2 px-4 rounded-lg">Save</button>
        </div>
      </form>
    </div>
  );
}

export default CommunityServiceForm;